module.exports = __webpack_public_path__ + "img/apple-logo-svgrepo-com.58fc698c.svg";